import { useReveal } from "../hooks/useReveal.js";
import { Nav } from "../components/Nav.jsx";
import { Hero } from "../sections/Hero.jsx";
import { Problem } from "../sections/Problem.jsx";
import { Idea } from "../sections/Idea.jsx";
import { Ecosystem } from "../sections/Ecosystem.jsx";
import { Philosophy } from "../sections/Philosophy.jsx";
import { ForWho } from "../sections/ForWho.jsx";
import { Manifesto } from "../sections/Manifesto.jsx";
import { FinalCTA } from "../sections/FinalCTA.jsx";
import { Footer } from "../sections/Footer.jsx";

export function HomePage() {
  const ref = useReveal();

  return (
    <div ref={ref}>
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Idea />
        <Ecosystem />
        <Philosophy />
        <ForWho />
        <Manifesto />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
